import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Component/Navbar Components/Home";
import img1 from "../src/Assets/1.png";

const root = ReactDOM.createRoot(document.getElementById("root"));
const meta = {
  title: 'Online interactive learning, courses, ebooks ',
  meta: {
    property: {
      'og:title': 'MentorG',
      'og:url': 'https://mentorg.org',
      'og:description': 'Learn hindi online, Online interactive learning, courses, ebook'
    }
  }
};



root.render(
  <React.StrictMode>
    <BrowserRouter>
      <div>



      </div>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
